import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoIconAccountDetails, LazySvgoIconAffiliates, LazySvgoIconAngleRight, LazySvgoIconApplePodcast, LazySvgoIconArticle, LazySvgoIconBadgePercent, LazySvgoIconCaretDown, LazySvgoIconCategories, LazySvgoIconCheck, LazySvgoIconClose, LazySvgoIconCollapse, LazySvgoIconCreditCard, LazySvgoIconDownload, LazySvgoIconExpand, LazySvgoIconEye, LazySvgoIconEyeClosed, LazySvgoIconFacebookColoured, LazySvgoIconGoogleColoured, LazySvgoIconHeart, LazySvgoIconHeartFilled, LazySvgoIconHome, LazySvgoIconHub, LazySvgoIconInfo, LazySvgoIconMagnifyingLens, LazySvgoIconMenu, LazySvgoIconMusic, LazySvgoIconOrders, LazySvgoIconPause, LazySvgoIconPlay, LazySvgoIconPower, LazySvgoIconRemoveRing, LazySvgoIconShareFacebook, LazySvgoIconShareLinkedin, LazySvgoIconShareTwitter, LazySvgoIconShareXTwitter, LazySvgoIconShoppingCart, LazySvgoIconSocialFacebook, LazySvgoIconSocialInstagram, LazySvgoIconSocialSoundcloud, LazySvgoIconSocialXTwitter, LazySvgoIconSocialYoutube, LazySvgoIconSoftware, LazySvgoIconSounds, LazySvgoIconSpinner, LazySvgoIconTags, LazySvgoIconTriangle, LazySvgoIconUser, LazySvgoIconUsers, LazySvgoIconVendors } from '#components'
const lazyGlobalComponents = [
  ["SvgoIconAccountDetails", LazySvgoIconAccountDetails],
["SvgoIconAffiliates", LazySvgoIconAffiliates],
["SvgoIconAngleRight", LazySvgoIconAngleRight],
["SvgoIconApplePodcast", LazySvgoIconApplePodcast],
["SvgoIconArticle", LazySvgoIconArticle],
["SvgoIconBadgePercent", LazySvgoIconBadgePercent],
["SvgoIconCaretDown", LazySvgoIconCaretDown],
["SvgoIconCategories", LazySvgoIconCategories],
["SvgoIconCheck", LazySvgoIconCheck],
["SvgoIconClose", LazySvgoIconClose],
["SvgoIconCollapse", LazySvgoIconCollapse],
["SvgoIconCreditCard", LazySvgoIconCreditCard],
["SvgoIconDownload", LazySvgoIconDownload],
["SvgoIconExpand", LazySvgoIconExpand],
["SvgoIconEye", LazySvgoIconEye],
["SvgoIconEyeClosed", LazySvgoIconEyeClosed],
["SvgoIconFacebookColoured", LazySvgoIconFacebookColoured],
["SvgoIconGoogleColoured", LazySvgoIconGoogleColoured],
["SvgoIconHeart", LazySvgoIconHeart],
["SvgoIconHeartFilled", LazySvgoIconHeartFilled],
["SvgoIconHome", LazySvgoIconHome],
["SvgoIconHub", LazySvgoIconHub],
["SvgoIconInfo", LazySvgoIconInfo],
["SvgoIconMagnifyingLens", LazySvgoIconMagnifyingLens],
["SvgoIconMenu", LazySvgoIconMenu],
["SvgoIconMusic", LazySvgoIconMusic],
["SvgoIconOrders", LazySvgoIconOrders],
["SvgoIconPause", LazySvgoIconPause],
["SvgoIconPlay", LazySvgoIconPlay],
["SvgoIconPower", LazySvgoIconPower],
["SvgoIconRemoveRing", LazySvgoIconRemoveRing],
["SvgoIconShareFacebook", LazySvgoIconShareFacebook],
["SvgoIconShareLinkedin", LazySvgoIconShareLinkedin],
["SvgoIconShareTwitter", LazySvgoIconShareTwitter],
["SvgoIconShareXTwitter", LazySvgoIconShareXTwitter],
["SvgoIconShoppingCart", LazySvgoIconShoppingCart],
["SvgoIconSocialFacebook", LazySvgoIconSocialFacebook],
["SvgoIconSocialInstagram", LazySvgoIconSocialInstagram],
["SvgoIconSocialSoundcloud", LazySvgoIconSocialSoundcloud],
["SvgoIconSocialXTwitter", LazySvgoIconSocialXTwitter],
["SvgoIconSocialYoutube", LazySvgoIconSocialYoutube],
["SvgoIconSoftware", LazySvgoIconSoftware],
["SvgoIconSounds", LazySvgoIconSounds],
["SvgoIconSpinner", LazySvgoIconSpinner],
["SvgoIconTags", LazySvgoIconTags],
["SvgoIconTriangle", LazySvgoIconTriangle],
["SvgoIconUser", LazySvgoIconUser],
["SvgoIconUsers", LazySvgoIconUsers],
["SvgoIconVendors", LazySvgoIconVendors],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
